import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import apiService from '../services/api';
import './IntegrationApplicationMasterData.css';

interface FrameworkStats {
  dimensions: number;
  components: number;
  attributes: number;
  questions: number;
}


const APRSetup: React.FC = () => {
  const [stats, setStats] = useState<FrameworkStats>({
    dimensions: 0,
    components: 0,
    attributes: 0,
    questions: 0
  });
  const [loading, setLoading] = useState(true);

  const loadFrameworkData = useCallback(async () => {
    try {
      setLoading(true);
      const frameworkStats = await apiService.getFrameworkStats();
      setStats(frameworkStats);
    } catch (error) {
      console.error('Failed to load framework data:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadFrameworkData();
  }, [loadFrameworkData]);


  if (loading) {
    return (
      <div className="apr-setup-page material-design">
        <div className="page-header">
          <div className="header-content">
            <h1>APR Setup</h1>
            <p>Loading framework configuration...</p>
          </div>
        </div>
        <div className="md-loading-state">
          <div className="md-spinner"></div>
          <h3>Loading APR Setup Data</h3>
          <p>Please wait while we fetch the latest framework configuration...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="page">
      {/* Header */}
      <div className="page-header">
        <div className="page-header__content">
          <div className="page-header__title-section">
            <h1 className="page-header__title">APR Setup</h1>
            <p className="page-header__subtitle">
              Configure and manage the Application Portfolio Rationalization framework components
            </p>
          </div>
          <div className="page-header__actions">
          </div>
        </div>
      </div>

      {/* Main Content Container */}
      <div className="master-data-container">

      {/* Framework Statistics */}
      <div className="md-stats-grid">
        <div className="md-card md-card--elevated">
          <div className="md-card-content">
            <div className="md-stat-primary">{stats.dimensions}</div>
            <div className="md-stat-label" style={{ fontSize: '14px', whiteSpace: 'nowrap' }}>📊 Dimensions</div>
          </div>
        </div>

        <div className="md-card md-card--elevated">
          <div className="md-card-content">
            <div className="md-stat-primary">{stats.components}</div>
            <div className="md-stat-label" style={{ fontSize: '14px', whiteSpace: 'nowrap' }}>🔧 Components</div>
          </div>
        </div>

        <div className="md-card md-card--elevated">
          <div className="md-card-content">
            <div className="md-stat-primary">{stats.attributes}</div>
            <div className="md-stat-label" style={{ fontSize: '14px', whiteSpace: 'nowrap' }}>⚖️ Attributes</div>
          </div>
        </div>

        <div className="md-card md-card--elevated">
          <div className="md-card-content">
            <div className="md-stat-primary">{stats.questions}</div>
            <div className="md-stat-label" style={{ fontSize: '14px', whiteSpace: 'nowrap' }}>❓ Q&A</div>
          </div>
        </div>
      </div>

      {/* Framework Management */}
      <div className="md-card">
        <div className="md-card-content">
          <h2 style={{ marginBottom: '24px', color: '#1976d2' }}>🚀 Quick Actions</h2>
          <div className="md-stats-grid">
            <Link to="/framework/dimensions" className="md-card md-card--elevated" style={{ textDecoration: 'none', color: 'inherit', cursor: 'pointer' }}>
              <div className="md-card-content">
                <div className="md-stat-primary" style={{ color: '#6366f1', fontSize: '24px' }}>
                  📊
                </div>
                <div className="md-stat-label" style={{ fontSize: '14px', whiteSpace: 'nowrap' }}>Dimensions Management</div>
                <div style={{ fontSize: '14px', color: '#666', marginTop: '4px' }}>
                  Configure assessment dimensions
                </div>
              </div>
            </Link>
            
            <Link to="/framework/components" className="md-card md-card--elevated" style={{ textDecoration: 'none', color: 'inherit', cursor: 'pointer' }}>
              <div className="md-card-content">
                <div className="md-stat-primary" style={{ color: '#8b5cf6', fontSize: '24px' }}>
                  🔧
                </div>
                <div className="md-stat-label" style={{ fontSize: '14px', whiteSpace: 'nowrap' }}>Components Management</div>
                <div style={{ fontSize: '14px', color: '#666', marginTop: '4px' }}>
                  Organize evaluation components
                </div>
              </div>
            </Link>
            
            <Link to="/framework/attributes" className="md-card md-card--elevated" style={{ textDecoration: 'none', color: 'inherit', cursor: 'pointer' }}>
              <div className="md-card-content">
                <div className="md-stat-primary" style={{ color: '#06b6d4', fontSize: '24px' }}>
                  ⚖️
                </div>
                <div className="md-stat-label" style={{ fontSize: '14px', whiteSpace: 'nowrap' }}>Data Attributes & Weightage</div>
                <div style={{ fontSize: '14px', color: '#666', marginTop: '4px' }}>
                  Configure attribute weights
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div>
      </div>
    </div>
  );
};

export default APRSetup;